import identity from 'lodash/identity';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import pickBy from 'lodash/pickBy';

/**
 * NOTE: arrays are not merged.
 */
export default function<T>(target: T, source: T): T {
  const output: T = {} as T;

  [source, pickBy(target as {}, identity)].forEach((item) => {
    mergeWith(output, item, (objectValue, sourceValue) => {
      return isArray(sourceValue) && sourceValue.length ? sourceValue : undefined;
    });
  });

  return output;
}
